//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    /**
     * Dropdown button text
     */
    buttonText: {
      type: String,
      default: ''
    },
    /**
     * Whether or not capitalize the dropdown text
     */
    capitalizeText: {
      type: Boolean,
      default: false
    },
    /**
     * Whether to apply just the bottom border
     */
    onlyBottomBorder: {
      type: Boolean,
      default: false
    },
    /**
     * Border color
     */
    borderColor: {
      type: String,
      default: '#000000'
    },
    /**
     * Font color
     */
    fontColor: {
      type: String,
      default: '#000000'
    }
  },
  computed: {
    cssClasses () {
      return ['base-dropdown', {
        'base-dropdown--border-bottom': this.onlyBottomBorder,
        'base-dropdown--border-square': !this.onlyBottomBorder
      }]
    },
    cssVars () {
      return {
        '--border-color': this.borderColor,
        '--font-color': this.fontColor
      }
    }
  }
}
